module.exports = "<script type=\"text/ng-template\" id=\"delete-employer-modal.html\">\n  <div class=\"modal-header\">\n    <center>\n      <h3>Delete Employer</h3>\n      <h5>Are you sure you want to delete this employer?</h5>\n    </center>\n  </div>\n  <div class=\"modal-footer\">\n    <center>\n      <button class=\"btn btn-info\" ng-click=\"ctrl.delete()\">Yes</button>\n      <button class=\"btn btn-default\" ng-click=\"ctrl.cancel()\">No</button>\n    </center>\n  </div>\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/shared/directives/delete-employer/delete-employer-modal.html
// module id = 460
// module chunks = 0